import { ProjectWithContactDto } from "./projectTypes";

export enum CrmContactStatus {
  ACTIVE = "ACTIVE",
  NO_FURTHER_CONTACT_DESIRED = "NO_FURTHER_CONTACT_DESIRED",
  POTENTIAL_FUTURE_PROJECT = "POTENTIAL_FUTURE_PROJECT",
}

export type IndustryDto = {
  industryId: number;
  description: string;
};

export type ContactPersonDto = {
  contactPersonId: number;
  companyId: number;
  name: string;
  crmContactAllowed?: boolean;
  crmContactStatus?: CrmContactStatus | null;
  crmContactStatusReason?: string | null;
};

export type CompanyShortDto = {
  companyId: number;
  companyName: string;
  industry: IndustryDto;
};

export type CompanyDto = {
  companyId: number;
  name: string;
  industry: IndustryDto;
  shortDescription: string | null;
  street: string | null;
  postalCode: string | null;
  city: string | null;
  addressAdditional: string | null;
  url: string | null;
  importantInformation: string | null;
  numberOfProjects: number;
  contactDesired: boolean;
  classified: boolean;
  contactPersons: ContactPersonDto[];
};

export type CompanyDetailsDto = CompanyDto & {
  projects: ProjectWithContactDto[];
};

export type CreateCompanyDto = {
  name: string;
  industry: IndustryDto;
  shortDescription: string;
  street: string;
  postalCode: string;
  city: string;
  addressAdditional: string;
  url: string;
  importantInformation: string;
  contactDesired: boolean;
  classified: boolean;
};

export type UpdateCompanyDto = {
  companyId: number;
  name: string;
  industry: IndustryDto;
  shortDescription: string;
  street: string;
  postalCode: string;
  city: string;
  addressAdditional: string;
  url: string;
  importantInformation: string;
  contactDesired: boolean;
  classified: boolean;
};

export type CompanyContactPersonNoteDto = {
  contactPersonNoteId: number;
  contactPersonId: number;
  contactPersonName: string;
  authorMemberId: number;
  authorName: string;
  createdAt: Date;
  note: string;
};

export type ContactPersonDetailsDto = {
  contactPersonId: number;
  companyId: number;
  companyName: string;
  name: string;
  salutation: string;
  position: string;
  mobilePhone: string;
  email: string;
  birthday: Date | null;
  jbtContactId: number | null;
  jbtContactName: string;
  crmContactAllowed?: boolean;
  crmContactStatus?: CrmContactStatus | null;
  crmContactStatusReason?: string | null;
};

export type CreateContactPersonDto = {
  companyId: number;
  name: string;
  salutation: string;
  position: string;
  mobilePhone: string;
  email: string;
  birthday: Date | null;
  jbtContactId: number | null;
  crmContactAllowed?: boolean;
  crmContactStatus?: CrmContactStatus | null;
  crmContactStatusReason?: string | null;
};

export type ContactPersonNoteDto = {
  noteId: number | string;
  contactPersonId: number;
  note: string;
  author: string;
  createdAt: Date | string;
};

export type CreateContactPersonNoteDto = {
  note: string;
};

export type ContactPersonProjectDto = {
  projectId: number;
  projectName: string;
  status: string;
};
